import React from 'react';
import { Global } from '@emotion/react';

const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'proxima-nova';
        src: url('https://cdn.jsdelivr.net/npm/font-proxima-nova@1.0.1/fonts/ProximaNova-Light.woff') format('woff');
        font-weight: 100;
        font-style: normal;
      }

      @font-face {
        font-family: 'proxima-nova';
        src: url('https://cdn.jsdelivr.net/npm/font-proxima-nova@1.0.1/fonts/ProximaNova-LightIt.woff') format('woff');
        font-weight: 300;
        font-style: normal;
      }

      @font-face {
        font-family: 'proxima-nova';
        src: url('https://cdn.jsdelivr.net/npm/font-proxima-nova@1.0.1/fonts/ProximaNova-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
      }

      @font-face {
        font-family: 'proxima-nova';
        src: url('https://cdn.jsdelivr.net/npm/font-proxima-nova@1.0.1/fonts/ProximaNova-Semibold.woff') format('woff');
        font-weight: 500;
        font-style: normal;
      }

      @font-face {
        font-family: 'proxima-nova';
        src: url('https://cdn.jsdelivr.net/npm/font-proxima-nova@1.0.1/fonts/ProximaNova-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
      }
    `}
  />
);
export default Fonts;
